<template>
  <div class="page-container">
    <div class="top-bar">
      <span>Insurer Account</span>
    </div>
    <div class="card mg-t-15">
      <div class="info-container">
        <h1>Manulife</h1>
        <div class="info-content">
          <div>
            <span class="label">Account Status</span>
            <div>
              <span class="span-checkbox">Active</span>
            </div>
          </div>
          <div>
            <span class="label">Joined</span>
            <span>
              2020-04-03
              17:12:13
            </span>
          </div>
          <div>
            <span class="label">Products</span>
            <span>1000</span>
          </div>
          <div>
            <span class="label">ID</span>
            <span>#126685</span>
          </div>
        </div>
      </div>
    </div>
    <el-tabs v-model="activeTab">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :label="tab.label"
        :name="tab.name"
      ></el-tab-pane>
    </el-tabs>
    <insurer-plans v-show="activeTab === 'Plans'" />
    <insurer-policies v-show="activeTab === 'Policies'" />
  </div>
</template>
<script>
import InsurerPlans from './components/insurer-plans'
import InsurerPolicies from './components/insurer-policies'
export default {
  name: 'InsurerAccount',
  components: {
    InsurerPlans,
    InsurerPolicies
  },
  data() {
    return {
      activeTab: 'Plans',
      tabList: [
        {
          label: 'Plans',
          name: 'Plans'
        },
        {
          label: 'Policies',
          name: 'Policies'
        }
      ]
    }
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.page-container {
    position: relative;
    padding-bottom: 100px;
  color: #303133;
  .top-bar {
    padding-top: 5px;
    color: #C64191;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #C64191;
  }
  .info-container {
        color: #616266;
        h1 {
          padding-bottom: 10px;
          font-size: 24px;
        }
        .info-content {
          display: flex;
          margin: 0 -15px;
          padding: 15px 15px 0 15px;
          border-top: 1px solid rgba(0, 0, 0, 0.1);
          color: #91939a;
          & > div {
              margin-right: 60px;
          }
          .label {
            display: block;
            margin-bottom: 10px;
            font-size: 14px;
            font-weight: bold;
            color: #616266;
          }
        }
      }
}
</style>